import React from "react";
import { InputFactory as _InputFactory, RelatedFactory } from "../../nq-component";
import { findObjectUseCase, saveObjectUseCase } from "../../usecases/object";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";
import Context from "../../AppContext";
import InputSelect from "../InputSelect";
import InputFile2 from "../InputImages";
import InputCamera from "../InputCamera";
import InputRelation from "../InputRelation";
import InputPointer from "../InputPointer";

const defaultProps = {};

function InputFactory({ type, _type, field, object, onChange, ...props }) {
  console.log("ob", object);
  const context = React.useContext(Context);
  const value = object && object[field];

  function _onChange(field, value) {
    if (object) {
      object[field] = value;
    }
    onChange(value, field);
  }

  switch (_type || type) {
    case "Related":
      return (
        <RelatedFactory
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          field={field}
          {...props}
        />
      );
    case "Relation2":
      return (
        <InputRelation
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          //   required={required}
          {...props}
        />
      );
    case "Pointer":
      //   const schema =
      //     props.schema ||
      //     context.schemas.find((s) => s.collection === props.target);
      //   if (!schema) return null;
      return (
        <InputPointer
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          findObject={findObjectUseCase()}
          schemas={context.schemas}
          //   required={required}
          {...props}
        />
      );
    case "Enum":
      return (
        <InputSelect
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          items={object}
          placeholder={
            props.placeholder ||
            (props.dynamic ? "Select of type " : "Select ") +
              (props.label || field)
          }
          {...props}
        />
      );
    case "Images":
      return (
        <InputFile2
          className="form-control"
          field="photos"
          onChange={_onChange.bind(this, field)}
          object={value}
          {...props}
        />
      );
    case "InputCamera":
      return (
        <InputCamera
          className="form-control"
          onChange={_onChange.bind(this, field)}
          object={value}
          {...props}
        />
      );

    default:
      return (
        <_InputFactory
          type={type}
          _type={_type}
          field={field}
          object={object}
          schemas={context.schemas}
          onChange={onChange}
          findObject={findObjectUseCase()}
          saveObject={saveObjectUseCase()}
          saveImage={saveImageUseCase()}
          saveFile={saveFileUseCase()}
          {...props}
        />
      );
  }
}

InputFactory.defaultProps = defaultProps;
export default InputFactory;
